module.exports = __webpack_public_path__ + "static/media/todo.ab612c41.gif";